const genericAlert = {
  verb: "was",
  create: "created",
  update: "updated",
  destroy: "deleted",
  archive: "archived",
  unarchive: "unarchived",
  new: "New",
  expired: "expired",
  copy: "copied",
};

const en = {
  action: {
    edit_state: "Edit state",
    update: "Update",
    load: "Load",
    export: "Export",
    back: "Back",
    next: "Next",
    select: "Select",
    cancel: "Cancel",
    create: "Create",
    save: "Save",
    save_new: "Save new",
    send: "Send",
    delete: "Delete",
    destroy: "Delete",
    remove_personal_data: "Remove personal data",
    remove: "Remove",
    close: "Close",
    duplicate: "Duplicate",
    archive: "Archive",
    unarchive: "Unarchive",
    manage_subscription: "Manage subscriptions",
    edit: "Edit",
    all: "All",
    apply: "Apply",
    link: "Link",
    unlink: "Unlink",
    impersonate: "Impersonate",
    add_text: "Add {type}",
    add_material: "Add material",
    add_work: "Add work",
    add_transport: "Add transport",
    add_note: "Add note",
    add_note_draft: "Continue note",
    add_transition: "Add transition",
    create_threat: "Create threat",
    create_vulnerability: "Create vulnerability",
    create_control: "Create control",
    add_field: "Add field",
    add_section: "Add section",
    add_provision: "Add provision",
    create_price_item: "Create price item",
    like: "Like",
    dislike: "Dislike",
    publish: "Publish",
    withdraw_article: "Withdraw article",
  },
  app_parts: {
    about: "About",
    account: "Account",
    activities: "Activites",
    main_administration: "Administration",
    articles: "Articles",
    asset_categories: "Asset categories",
    asset_groups: "Asset groups",
    assets: "Assets",
    audits: "Audits",
    automated_actions: "Automated actions",
    background_jobs: "Background jobs",
    app_settings: "App settings",
    connectors: "Connectors",
    contracts: "Contracts",
    controls_management: "Controls management",
    dashboard_screens: "Dashboards",
    data_sets: "Filters",
    devices: "Devices",
    document_settings: "Document settings",
    documents: "Documents",
    standby_plan: "Standby plan",
    external_emails: "External emails",
    fields: "Fields",
    feedback: "Feedback",
    holidays: "Holidays",
    consequences: "Consequences",
    main_implementation: "Implementation",
    import_assets: "Assets imports",
    import_contracts: "Contracts import",
    import_documents: "Documents import",
    import_fields: "Fields import",
    import_holidays: "Holidays import",
    import_issues: "Issues import",
    import_controls: "Controls import",
    import_persons: "Persons import",
    import_price_items: "Items import",
    import_price_lists: "Price items import",
    import_rules: "Rules import",
    import_services: "Services import",
    import_standards: "Standards import",
    import_tag_definitions: "Tags import",
    import_templates: "Templates import",
    import_threats: "Threats import",
    import_threat_categories: "Threat categories import",
    import_translations: "Translations import",
    import_users: "Users import",
    import_issue_priorities: "Issue priorities import",
    import_person_relations: "Person relations import",
    import_vulnerabilities: "Vulnerabilities import",
    import_warehouses: "Warehouse items import",
    installation: "Installation",
    issue_priorities: "Issue priorities",
    issues: "Issues",
    kpis: "KPI",
    license: "License",
    mail_server: "Email server",
    main_assets: "Assets",
    main_audits: "Audits",
    main_connectors: "Connectors",
    main_dashboard_screens: "Dashboards",
    main_documents: "Documents",
    main_issues: "Issues",
    main_persons: "Persons",
    main_risk_management: "Risk management",
    main_services: "Services",
    main_warehouses: "Warehouses",
    maintenance_plan: "Maintenance plan",
    mappers: "Mappers",
    controls: "Controls",
    notice: "Notice",
    notifications: "Notifications",
    permissions: "Permissions",
    person_relations: "Person relations",
    person_categories: "Person categories",
    persons: "Persons",
    planning_calendar: "Planning calendar",
    preferences: "Preferences",
    price_items: "Items",
    price_lists: "Price lists",
    likelihoods: "Likelihoods",
    profile: "Profile",
    portal: "Self-service portal",
    public_form: "Public issue form",
    reports: "Reports",
    risk_management: "Risk management",
    risk_levels: "Risk levels",
    risks: "Risk analysis",
    roles: "Roles",
    rules: "Rules",
    services: "Services",
    main_settings: "Settings",
    snippets: "Snippets",
    standard_soas: "Statements of applicability",
    standards: "Standards",
    statistics: "Statistics",
    subscriptions: "Subscriptions",
    tag_definitions: "Tags",
    threats: "Threats",
    threat_categories: "Threat categories",
    translations: "Translations",
    user_settings: "Default user settings",
    users: "Users",
    vulnerabilities: "Vulnerabilities",
    warehouses: "Warehouses",
    teams: "Teams",
    knowledge_base: "Knowledge base",
  },
  form: {
    hint: {
      global_search: "Search for item by name...",
      knowledge_base_search: "Search in the knowledge base...",
      knowledge_base_search_hint: "Find answers, guides and FAQs...",
      all_tasks:
        "It will also filter tasks that are not active (The issue is in a different state than the one required to perform the task).",
    },
    placeholder: {
      date: "YYYY-MM-DD",
      time: "HH:MM",
    },
    label: {
      acceptable: "Acceptable",
      activity_type: "Activity type",
      activity: {
        entity_id: "Object ID",
        entity_type: "Object type",
        person_id: "Author - Person",
        connector_id: "Author - Connector",
      },
      aggregate: "Aggregate",
      all_tasks: "All tasks",
      apply: "Apply",
      apply_from: "Apply from",
      apply_to: "Apply_to",
      archive_all: "Archive an object with all children",
      archived_at: "Archived",
      asset_category_id: "Asset category",
      asset_group_id: "Asset group",
      asset_id: "Asset",
      asset_with_children: "With children items",
      attempts: "Attempts",
      audit_id: "Audit",
      author: "Author",
      author_system: "Author - System",
      auto_center: "Auto center",
      automated_action_id: "Author - Automated action",
      automated_action_type: "Automated action type",
      availability: "Availability",
      available_for_limited_users:
        "Available in self-service portal for limited users",
      blocked: "Blocked",
      budget: "Budget",
      calculation: "Calculation",
      cancel: "Cancel",
      clear: "Clear",
      category_id: "Category",
      change_parent: "Change the parent of all children",
      character: "Char.",
      closed_at: "Closed at",
      code_1: "Code 1",
      code_2: "Code 2",
      column_filter: "Column filter",
      confidentiality: "Confidentiality",
      connector_id: "Connector",
      contract_id: "Contract",
      contract_type: "Contract type",
      count: "Count",
      created_at: "Created at",
      created_by: "Created by",
      created_from: "Created from",
      created_to: "Created to",
      author_id: "Author - Person",
      currency: "Currency",
      current_hint: "0 means current",
      current_teams: "Current user's teams",
      current_risk_level_id: "Current risk level",
      customer_id: "Customer",
      dashboard_screen_id: "Dashboard",
      data_set_id: "Filter",
      data_type: "Data type",
      date_from: "Date from",
      date_to: "Date to",
      description: "Description",
      detail: "Field in detail",
      detail_on_asset: "Field in asset detail",
      display: "Display",
      effective_at: "Effective at",
      email: "Email",
      en: "Translation EN",
      entity_id: "Relation ID",
      entity_type: "Object type",
      error: "Error loading filter",
      evidence: "Evidence",
      expense: "Expense",
      external_email_id: "Author - External email",
      failed_at: "Failed",
      feedback_rating: "Feedback rating",
      field: "Group by",
      file: "File",
      file_size_range: "Size",
      files: "Files",
      findings: "Findings",
      fixed: "Fixed",
      from: "From",
      gdpr_privacy_policy: "Privacy Policy",
      gtin: "GTIN",
      hide_logo: "Hide logo",
      id: "ID",
      identifier: "Identifier",
      information_unavailable: "Information unavailable",
      integrity: "Integrity",
      issue: {
        person_id: "Responsible person",
      },
      issue_category_id: "Issue category",
      issue_priority_id: "Priority",
      issue_types: "Issue types",
      issue_type: "Issue type",
      kb_admin: "Knowledge Base Administrator",
      kpi_id: "KPI",
      key: "Key",
      last: "Last",
      mapper_id: "Mapper",
      maximum: "Maximum",
      control_id: "Control",
      minimum: "Minimum",
      name: "Name",
      new_parent: "Move under parent",
      no_value_option_asset: "Show assets without {type}",
      no_value_option_document: "Show documents without {type}",
      no_value_option_issue: "Show issues without {type}",
      no_value_option_person: "Show persons without {type}",
      no_value_option_requirement: "Show requirements without {type}",
      no_value_option_risk: "Show risks without {type}",
      note: "Note",
      not_assigned: "Not assigned",
      not_created_by_responsible: "Issue not created by responsible person",
      offset: "Offset",
      on: "Turn on",
      on_page: "on this page",
      operations: "Operations",
      operations_header: "Operations over selected items",
      organization_id: "Organization",
      otp_required_for_login: "Two factor authentication",
      overlap: "Overlap",
      owner: "Owner",
      owner_id: "Owner",
      paragraph: "§",
      parent_id: "Belongs to",
      period: "Period",
      period_filter_method: "Period filtering method",
      persistence: "Existence",
      person_relation_id: "Relation",
      person_category_id: "Person category",
      person_id: "Person",
      picture: "Picture",
      point: "Point",
      price_list_id: "Price list",
      price_type: "Item type",
      properties: "Properties",
      public: "Public",
      public_token_valid: "Only public",
      range: "Range",
      receipt: "Receipt",
      relation_type_id: "Relation ID",
      report_id: "Report",
      report_type: "Report type",
      resolve_at: "Resolve to",
      residual_risk_level_id: "Residual risk level",
      risk_reduction: "Risk reduction",
      risk_level_id: "Risk level",
      risk_type: "Risk type",
      rm_admin: "Risk Management Administrator",
      role_id: "Role",
      team_id: "Team",
      reponsible_persons: "Responsible persons",
      rm_asset_type: "Used in risk management as",
      row: "Row",
      rule_id: "Author - Rule",
      run_at: "Run",
      run_type: "Run type",
      service_id: "Service",
      service_organization_id: "Service organization",
      select_all: "Select all",
      selected: "selected",
      show_legend: "Show legend",
      sk: "Translation SK",
      solution: "Solution",
      solve_status: "Solving status",
      sort: "Sort by",
      sort_desc: "Sort descending",
      standard_id: "Law and Standard",
      standard_soa_id: "Statement of Applicability",
      start_of_working_hours: "Start of working hours",
      state: "State",
      status: "Status",
      subscription_type: "Subscription type",
      subsection: "Sec.",
      sum: "Sum",
      table_headers: "Table columns",
      tag_definitions: "Tags",
      tag_definition_id: "Tag",
      target_entity: "Target data type",
      threat_id: "Threat",
      threat_category_id: "Category",
      tier: "User type",
      till_now: "till now",
      time_filter: "Date field",
      time_from: "Time from",
      time_to: "Time to",
      to: "To",
      transfer: "Transfer",
      type: "Type",
      unit: "Unit",
      updated_at: "Last update at",
      use_current_user: "Current user",
      user_id: "Responsible person",
      valid_at: "Valid at",
      value: "Value",
      value_in_detail: "Value in detail",
      visualization: "Visualization",
      vulnerability_id: "Vulnerability",
      warehouse_id: "Warehouse",
      with_user: "With user",
      source_warehouse_id: "Source warehouse",
      target_warehouse_id: "Target warehouse",
      price_item_id: "Item",
      whole: "Whole",
      with_children: "With children items",
      working_color: "Icon color for assets without issue",
      working_hide: "Do not display assets without issues",
      xtitle: "X-axis description",
      ytitle: "Y-axis description",
      zoom: "Zoom",
      date: "Date",
      time: "Time",
    },
    error: {
      required: "This field is required",
      valid: "This field is invalid",
      length_min_max: "Must contain at least {min} and at most {max}",
      length_min: "Must contain at least {min}",
      length_max: "Must contain at most {max}",
      characters_count: "{n} character | {n} characters",
      json: "Must contain valid JSON",
      value_min_max: "Value must be min {min} and max {max}",
      value_min: "Value must be min {min}",
      value_max: "Value must be max {max}",
      value_higher: "Value must be higher than {value}",
      value_lower: "Value must be lower than {value}",
      value_higher_equal_zero: "Value must be equal or higher than 0",
      value_custom_range:
        "Value must be equal or higher than {min} and equal or lower than {max}",
      value_higher_equal_0_lower_equal_custom_value:
        "Value must be equal or higher than 0 and equal or lower than {value}",
      not_zero: "Value can't be 0",
      email: "Must be valid email address",
      multi_email: "Must contain only valid email addresses",
      big_file: "File size exceeds limit",
      max_files: "Maximum number of files is {max}",
      not_in_past: "Date can't be in past",
      must_contain_number: "Must contain at least one digit",
      must_contain_lower: "Must contain at least one lower case letter",
      must_contain_upper: "Must contain at least one upper case letter",
      items_min_max: "Number of items must be min {min} and max {max}",
      later_date: "Date must be later than '{prev}'",
      match_password: "Must match password",
    },
  },
  enum: {
    boolean: {
      no: "No",
      yes: "Yes",
    },
    week_first_day: {
      monday: "Monday",
      sunday: "Sunday",
    },
  },
  other: {
    actions: "Actions",
    info: "Info",
    summary: "Summary",
    other: "Other",
    tags: {
      subscribe: "Notifications turned on",
      children_count: "Number of child items",
    },
    language: {
      sk: "Slovak",
      en: "English",
    },
    basic_info: "Basic information",
  },
  first_login: {
    cookies:
      "I am aware that the application uses cookies and I agree to that ",
    personal_info_GDPR: "I accept processing my personal information ",
    license: "I accept EULA",
    accept: "Accept",
    decline: "Decline",
    welcome: "Welcome in AUSEMIO",
    link_text: "More information",
    headers: {
      cookies: "About cookies usage on this page",
      gdpr: "Data processing",
    },
  },
  tooltips: {
    navbar_icons: {
      log_out: "Log out",
      locales_switch: "Select language",
      notifications: "Notifications",
      documentation: "Documentation",
      search: "Use # + Id number for search by Id",
      search_shortcut: "Search ( S )",
      stop_impersonating: "Stop impersonating user",
      list: "List view",
      card: "Cards view",
      tree: "Tree view",
      map: "Map view",
      cal: "Calendar view",
    },
    show_buttons: {
      add: "Create new object",
      add_new_transition: "Add new state transition",
      add_shortcut: "Create new object ( C )",
      show_previous_note: "Show previous note",
      hide_previous_note: "Hide previous note",
      apply_plan_shortcut: "Apply plan ( A )",
      apply_controls: "Apply controls",
      new_note: "Create new note",
      reply_to_note: "Reply",
      reply_to_note_draft: "Continue replying to note",
      forward_note: "Forward",
      copy_link: "Copy link to note",
      create_solution_from_note: "Create solution from note",
      edit: "Edit object",
      change_state: "Change issue state",
      assign_me: "Take over the issue",
      add_location: "Add location",
      edit_location: "Edit location",
      new_document: "Create and link new document",
      import: "Import from file",
      new_material_report: "Material report",
      new_work_report: "New work report",
      new_transport_report: "New transport report",
      link_object: "Link existing objects",
      link_document: "Link existing documents",
      show_in_documents: "Open in Documents",
      show_in_issues: "Open in Issues",
      run_applying: "Start applying the control",
      passwd_change: "Change password",
      other: "Other actions",
      new_option: "New option",
      add_issue: "Create issue",
      operations: "Operations ( O )",
      filter: "Filter ( F )",
      filter_inside: "Filter ( Shift + Enter )",
      filter_actions: "Filter actions",
      filter_config: "Filter configuration",
      clear_filter_shortcut: "Clear filter ( Shift + Backspace )",
      apply: "Apply",
      setup_permissions: "Setup permissions",
      navigate: "Navigate",
      download: "Download",
      use_translation: "Use translation",
      find_by_qr: "Find asset by BAR/QR code",
      use_optional_translation: "Use text without translation",
      add_DataSet_dashlet: "Add filter dashlet",
      add_Kpi_dashlet: "Add KPI dashlet",
      add_Calendar_dashlet: "Add calendar dashlet",
      add_threat: "Create and add new threat",
      add_vulnerability: "Create and add new vulnerability",
      add_control: "Create and add new control",
      add_section: "Add new section",
      add_provision: "Add new provision",
      add_price_item: "Create new price item",
      create_template_assignment: "Create template",
      apply_planned_control: "Apply planned control",
      bulk_add_applied: "Mark selected assets as applied",
      bulk_remove_applied: "Mark selected assets as not applied",
      bulk_add_planned: "Mark selected assets as planned",
      bulk_remove_planned: "Mark selected assets as not planned",
      new_task: "Create new task",
      new_sla: "Create new SLA",
      open_task_tab: "Open tasks",
      acceptance: "Accepting the solution of the issue",
      close_issue: "Close issue",
      knowledge_base_search: "Open knowledge base",
      create_article: "Create article",
    },
    disabled_buttons: {
      add: "You do not have permission to create new object",
      add_new_transition:
        "You do not have permission to add new state transition",
      new_note: "You do not have permission to create new note",
      note_reply: "You do not have permission to reply to the note",
      edit: "You do not have permission to edit object",
      new_location: "You do not have permission to create location",
      no_filter: "You have no active filter",
      generic: "You do not have permission for this action",
      fields_echo: "You have not entered all fields",
      no_issue: "No new issue needed",
      no_warehouse_items: "This item is out of stock",
      warehouse_delete: "Balance must be 0",
      no_batches: "Item has no batches",
    },
    tabs_icons: {
      search: "Search",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      priority_move_up: "Increase priority",
      priority_move_down: "Decrease priority",
      move_up: "Move up",
      move_down: "Move down",
      checklist_preview: "Checklist preview",
      empty: "No tooltip defined !!!",
      add: "Add",
      preview: "Preview",
      detail: "Show detail",
      show_in_cal: "Show all resources in calendar",
      history_of_asset_issues: "View the history of issues on this asset",
    },
    show_archived: "Show archived",
    hide_archived: "Hide archived",
    show_assets_calendar_tooltip: {
      table_view: "Table",
      graphic_view: "Plan",
    },
  },
  generic: {
    application: "Application",
    archive: "Archive",
    back_to_login: "Back to login",
    camera: "Camera",
    code: "Code",
    conf_new_passwd: "Confirm new password",
    drop_files_message: "Drop files here to upload",
    error_value: "Error value",
    false: "No",
    filter_active: "Filter is active",
    forgot: "Forgot your password?",
    item: "Item",
    log_in: "Log in",
    log_in_header: "Log in",
    message: "Message",
    new_passwd: "New password",
    object: "Object",
    others: "others",
    password: "Password",
    copyright: "Copyright © 2023",
    reader: "Reader",
    run: "Run",
    scan: "Scan",
    scan_qr: "Scan QR/BAR Code",
    send_reset: "Restore",
    set_passwd: "Set new password",
    show_less: "Show less",
    show_more: "Show more",
    system: "System",
    total_count: "Total count",
    true: "Yes",
    two_factor_auth_code: "Verification code",
    unknown: "Unknown",
    unset: "Unset",
  },
  date_parts: {
    second: "second",
    minute: "minute",
    hour: "hour",
    day: "day",
    week: "week",
    month: "month",
    year: "year",
  },
  // TC translations
  minute: "1 minute | {n} minutes",
  day: "1 day | {n} days",
  day_l: "day | days",
  week: "1 week | {n} weeks",
  month: "1 month | {n} months",
  year: "1 year | {n} years",
  messages: {
    publicIssue: {
      cameraAllow: "Allow camera permission to scan QR",
      noCamera: "ERROR: No camera on this device",
      httpsNeeded: "HTTPS is needed to scan QR code",
      cameraInUse: "ERROR: Is the camera already in use?",
      cameraFront: "Device does not have front or rear camera",
      streamAPI: "ERROR: Stream library is not supported in this browser",
    },
    login: {
      success: "Successfully logged in",
      error: "Failed to logged in. Wrong email or password.",
      error_two_factor: "Failed to logged in. Invalid authentication code.",
    },
    logout: "Successfully logged out",
    pageLoadAuthenticationError:
      "Authentication failed. Please log in to continue.",
    appPartNoAccess: "You don't have permission on this application part",
    passwordReset: {
      error:
        "Error setting new password: {errors}. To generate a new password reset link, click on 'RESTORE'. If the error persists, please contact the administrator.",
      success: "Password changed",
      instructionsSend:
        "We have sent you a password reset link to your email account. Follow the steps to reset your password. In case of non-delivery, please check the spam or the correctness of the entered email through which you are registered with us.",
      instructionsSendError:
        "Error sending reset password instructions by email",
    },
    globalSearchError: "Can't load results",
    treeLoadError: "Error loading tree",
    will_permanently: "will be permanently",
    question: "Do you want to continue?",
    cant: "Can't",
    noPermissionError: "You don't have permissions.",
    select: "Select",
    noDataListPermissions: "You don't have permissions to any item",
    empty_import_file: "Your file does not contain data for import",
    mapTooMuchData:
      "You have selected too many objects (more than 1000), the simultaneous display of which would make the visualization on the map significantly slower. Use the filter to select a smaller set.",
    moreThenAnother: "{firstName} must be greater than {secondName}.",
    check: "You probably didn't enter all the fields correctly",
    scanErr: "Invalid GTIN",
    scanErrorBatch: "A batch is required for this scanned item",
    notInList: "Item {name} {batch} not on the list",
    no_icon: "Please select icon",
    notInChecklist: "This asset is not part of this checklist",
    close_transaction:
      "Closing a transaction, this step will definitely close your transaction, it will no longer be possible to change it.",
    license: {
      user_exceeded:
        "Thank you for using the AUSEMIO platform. To add more users, please primarily contact your supplier or contact us at {web}.",
      connector_exceeded:
        "Thank you for using the AUSEMIO platform. To add more connectors, please primarily contact your supplier or contact us at {web}.",
    },
    original_parent_archived:
      "The original parent is archived, please select a new parent",
    remove_personal_data:
      "Removes the personal data in the person tab and all data with the personal data flag in the templates.",
    personal_data_removed: {
      success: "Personal data has been removed.",
      error: "It is not possible to remove personal data.",
    },
    multi_operations: {
      no_objects: "No ${model_plural} selected",
    },
    impersonate: {
      success: "You are now impersonating user {person}",
    },
    image: {
      tooLarge: "Image is too large. Maximum size is 5MB.",
      uploadFailed: "Image upload failed",
      invalidImageType: "Invalid image type",
    },
    solution_missing_warning:
      "Issue has no solution, please add the solution in the section",
    moreResults: "There are more results, please refine your search.",
  },
  dataTableMessages: {
    filter: {
      name: "Filter items by name",
    },
    emptyData: {
      headerPt1: "No data visible for ",
      headerPt2: ", here are tips why",
      filterReason: "No data available for chosen filter conditions",
      emptyDatabaseReason: "No created data in database",
      permissionReason: "You do not have permissions to see data",
      genericEmptyDataMessage:
        "There are no objects created or you do not have permission to see them",
      loading: "Loading data, please wait",
      text: "No results found",
      scanner: "Please start scanning items",
      warehouse: "Please select warehouse",
    },
    bottomNavbar: {
      list: "List",
      tree: "Tree",
      map: "Map",
      card: "Cards",
    },
  },
  sorts: {
    asc: "Ascending",
    desc: "Descending",
    created_at: {
      asc: "Oldest first",
      desc: "Newest first",
    },
    updated_at: {
      asc: "Long ago",
      desc: "Recently",
    },
    discarded_at: {
      asc: "Long ago",
      desc: "Recently",
    },
    name: {
      asc: "A - Z",
      desc: "Z - A",
    },
    category: {
      name: {
        asc: "A - Z",
        desc: "Z - A",
      },
    },
    issue_priority_id: {
      asc: "Lowest first",
      desc: "Highest first",
    },
  },
  person: {
    person: "Person",
    persons: "Persons",
    acc: "person",
    tree: "Persons tree",
    alert: genericAlert,
    label: {
      avatar: "Picture",
      submenu: {
        new_user: "Create user",
      },
      associated_user: "Create person with associated user",
    },
  },
  asset: {
    asset: "Asset",
    assets: "Assets",
    acc: "asset",
    tree: "Assets tree",
    card: "Asset cards",
    alert: genericAlert,
    label: {
      avatar: "Picture",
      applied: "Applied",
      properties: "Asset properties",
      submenu: {
        new_issue: "Create issue",
      },
      dependent: "Dependent on",
      depends: "Depends on",
      view_all: "Display",
      type: "Asset type",
      added_assets: "Added assets",
      filtered_assets: "Filtered assets",
      add_assets: "Add selected assets",
    },
    confidentiality_types: {
      public: "Public",
      internal: "Internal",
      protected: "Protected",
      strictly_protected: "Strictly protected",
    },
    integrity_types: {
      low: "Low",
      medium: "Medium",
      high: "High",
    },
    availability_types: {
      low: "Low",
      medium: "Medium",
      high: "High",
    },
    rm_asset_types: {
      primary: "Primary asset",
      supporting: "Supporting asset",
    },
    select_type: "Asset selection type",
    asset_filters: "Asset filters",
    search_assets: "Search assets",
  },
  document: {
    document: "Document",
    documents: "Documents",
    acc: "document",
    label: {
      entity_document: "Linked objects",
      dialog_entity_type: "Object type",
      select_objects: "Select object",
      less_than_1_mb: "Less than 1 MB",
      size: "Size",
      gallery: "Gallery of documents",
      table_view: "Table",
      gallery_view: "Gallery",
      noPreview: "A preview of this file type is not available",
      preview: "Preview",
      public_token_valid: "Public",
      attachments: "Attachments",
      without_relation: "Without relation",
      submenu: {
        compress: "Compress Image",
        new_folder: "Create new folder",
        add_doc: "Add document",
      },
    },
    public_form: {
      sorry: "Sorry, can't display document.",
    },
    alert: genericAlert,
  },
  folder: {
    folder: "Folder",
    acc: "folder",
    alert: genericAlert,
    files_location: "Location of uploaded files",
  },
  contract: {
    contract: "Contract",
    contracts: "Contracts",
    acc: "contract",
    alert: genericAlert,
    contract_types: {
      fixed_prolong: "Fixed length with automatic prolongation",
      fixed_end: "Fixed length",
      indefinite: "Indefinite period",
    },
    label: {
      customer: "Customer",
      service_organization: "Service organization",
      contract_type: "Contract type",
      valid_from: "Valid from",
      effective_from: "Effective from",
      effective_to: "Effective to",
      effective_at: "Effective at",
      prolongation_interval: "Prolongation interval",
      notice_period: "Notice period",
      submenu: {},
    },
    hint: {
      customer: "Person that receives service",
      service_organization: "Person that provides service",
      valid_from: "Start of validity",
      effective_from: "Start of effectiveness",
      effective_to: "End of effectiveness and validity",
      notice_period: "Interval of notice period",
      prolongation_interval: "Interval of prolongation",
    },
  },
  service: {
    service: "Service",
    services: "Services",
    acc: "service",
    alert: genericAlert,
    label: {
      resolve_plan: "Planned resolving",
      resolve_true: "True resolving",
      assets_revisions: "Asset revisions",
      workflow: "Workflow",
      copy_tasks: "Copy tasks",
      copy_templates: "Copy templates",
      copy_sla: "Copy SLA",
      copy_permissions: "Copy permissions",
      setup_all: "Select a checklist for all categories",
      submenu: {
        new_issue: "Create issue",
      },
      allowed_tags: "Allowed tags",
      working_hours: "Working hours",
      standby_plan: "Standby plan",
      public: "Public service",
      public_issue_type: "Type of public issue",
      issue_categories: "Categories",
      predefined_solver: "Predefined solver",
      color: "Service color",
    },
    issue_types: {
      Incident: "Incident",
      Request: "Request",
      Change: "Change",
      Problem: "Problem",
    },
    messages: {
      hint: "The diagram will be generated in the background and the file will be saved to service documents. You will be notified about completion by a notification in the application.",
    },
    add_assets_dialog: "Setup assets for service",
  },
  service_link: {
    service_link: "Support service",
    service_links: "Support services",
    acc: "support service",
    alert: genericAlert,
    label: {
      service_links_for_incident: "Support services for incidents",
    },
  },
  service_person: {
    service_person: "Service person",
    service_persons: "Service persons",
    acc: "service person",
    alert: genericAlert,
  },
  standby_time: {
    standby_time: "Standby time",
    standby_times: "Standby times",
    acc: "standby time",
    alert: genericAlert,
  },
  rule: {
    rule: "Rule",
    rules: "Rules",
    acc: "rule",
    alert: genericAlert,
    label: {
      valid_from: "Valid from",
      valid_to: "Valid to",
      repeat: "Repeat",
      in_advance: "Create issue in advance",
      required_by_law: "Required by law",
      valid_at: "Valid at",
      filter: "Filter definition",
    },
    tooltip: {
      no_issue: "No issue assigned",
      missing_resolve_at: "Issue assigned without resolve to",
      create_issue: "Create initialization issue for selected assets",
      select_asset: "Select at least 1 asset",
    },
    hint: {
      repeat: "Interval between service check",
    },
  },
  calendar: {
    calendar: "Calendar",
    planning_calendar: "Planning calendar",
    maintenance_plan: "Maintenance plan",
    type: "Type",
    hours_from: "Selected hours",
    hours_to: "to",
    drag: "Drag to calendar",
    drag_tooltip: "For drag choose person",
    week: "Week",
    apply: "Apply plan",
    today: "Today",
    label: {
      time_from: "Display from",
      time_to: "Display to",
      table_mode: "Table",
    },
    coloring: {
      label: "Coloring",
      default: "Default",
    },
    types: {
      month: "Month",
      week: "Week",
      day4: "4 days",
      day: "Day",
      year: "Year",
      scheduler: "Scheduler",
    },
    apply_dialog: {
      total: "Total",
      success: "Successfully planned",
      fail: "Fail to plan",
      not_changed: "Already planned",
      source: "Source of failure",
      no_plan_state: "State not configured",
      no_transition: "Transition not found",
      transition_fail: "Transition error: {message}",
    },
  },
  issue: {
    issue: "Issue",
    issues: "Issues",
    acc: "issue",
    alert: genericAlert,
    label: {
      timeline: "Timeline",
      services: "SLA/Services",
      transactions: "Transactions",
      change_state: "Change state",
      assign_me: "Take over",
      create: "Create",
      update: "Update",
      destroy: "Delete",
      to: "to",
      difference: "Difference",
      identifier: "Identifier",
      planned_at: "Planned at",
      resolve_at: "Resolve to",
      closed_at: "Closed at",
      assets_from_filter:
        "Issue will be created with {n} item of asset | Issue will be created with {n} items of asset",
      public_token_valid: "Public",
      public_link: "Public link",
      resolve_from: "Resolve from",
      resolve_to: "Resolve to",
      change_status_dialog: "Change issue status",
      no_state: "No state",
      and_more: " and {number} more",
      solution: "Solution",
      write_solution: "Write solution",
      use_existing_note_as_solution: "Use existing note",
      copy_note_as_solution: "Copy note",
      copy_from_existing_note: "Copy content from an existing note (optional)",
      select_note_to_mark_as_solution: "Select a note to mark as the solution",
      mark_as_solution: "Mark as solution",
      display_closed: "Display closed issues",
      submenu: {
        link_issue: "Linked issues",
      },
      issues_history: "Issues history",
      change_service: "Change service",
      switch_to_service: "Switch to service",
      requested_service: "Requested service",
      requested_state: "Requested state",
      type: "Issue type",
      tasks: "Tasks",
      status: "Status",
      assigned_person: "Responsible person",
      acceptance: "Acceptance",
      accept: "Accept",
      refuse: "Refuse",
      change_assigned_person: "Change responsible person",
      add_assigned_person: "Add responsible person",
      assign_person_first:
        "For planning, it is first necessary to assign a responsible person for issue.",
      planning_allowed: "Planning is now allowed for issue {issue_name}",
      change_priority: "Change priority",
      correct: "Issue correction",
      close: "Close",
      links: "Links",
      method_of_closure: "Method of closure",
      issue_detail: "Issue details",
      custom_fields: "Custom fields",
    },
    close_reasons: {
      duplicate: "Close as duplicate",
      invalid: "Close as invalid",
      known_error: "Close as known error",
    },
    hint: {
      service: "Service that covers issue",
    },
    public_form: {
      new: "New Issue",
      continue: "Continue",
      back: "Back",
      skip: "Skip",
      qr_code: "Failure on",
      email: "Your contact email",
      title: "Reporting issue",
      title_files: "Do you have files related to the issue?",
      description_files:
        "You can optionally attach up to 5 images or other files to your issue.",
      title_qr: "Is visible QR code on asset?",
      description_qr:
        "Scanning the QR code broken asset can help resolving the problem. " +
        "If there is no QR code or your device doesn't have camera, you can skip this step.",
      title_contact: "Let us contact on you",
      description_location:
        "Saving your current location can help us find the problem faster.",
      location_header: "Do you want to save the exact location of the issue?",
      location_save: "Save current location",
      location_info:
        "You must have location sharing enabled in your browser to save your current location. " +
        "If you have disabled browser location sharing and want to use location, " +
        "you will need to change this setting and reload the page.",
      description_contact:
        "Please let us contact on you. " +
        "We need it for future communication and informing you about resolving the problem.",
      title_thank: "Thank you for your report",
      description_thank:
        "Progress of solving your issue can be tracked by link sent to your email.",
      sorry: "Sorry, can't display issue.",
    },
    issue_types: {
      Incident: "Incident",
      Request: "Request",
      Change: "Change",
      Problem: "Problem",
    },
    statuses: {
      new: "New",
      assigned: "Assigned",
      resolution: "Resolution",
      resolution_waiting: "Waiting for Resolution",
      approval_waiting: "Waiting for Approval",
      assessment_waiting: "Waiting for Assessment",
      planning_waiting: "Waiting for Planning",
      analysis_waiting: "Waiting for Analysis",
      testing_waiting: "Waiting for Testing",
      deploying_waiting: "Waiting for Deployment",
      resolved: "Resolved",
      closed: "Closed",
      assessment: "Assessment",
      planning: "Planning",
      analysis: "Analysis",
      approval: "Approval",
      invalid: "Invalid",
      known_error: "Known error",
      rejected: "Rejected",
      duplicate: "Duplicate",
      testing: "Testing",
      deploying: "Deploying",
    },
    feedback: {
      title: "Rate Your Experience",
      subtitle: "How satisfied are you with the resolution?",
      additional_feedback: "Additional Feedback (Optional)",
      message_label: "Your message",
      message_placeholder:
        "Please share any additional thoughts or suggestions...",
      rating_required: "Please select a rating",
      rating_select: "Click to rate",
      thank_you_title: "Thank you for your feedback!",
      thank_you_message:
        "Your review has been successfully submitted. We appreciate you taking the time to share your experience.",
      error_message:
        "This issue has already been rated. It cannot be rated again.",
    },
    feedback_ratings: {
      0: "No Rating",
      1: "Very Unsatisfied",
      2: "Unsatisfied",
      3: "Average",
      4: "Satisfied",
      5: "Very Satisfied",
    },
  },
  issue_category: {
    issue_category: "Issue category",
    issue_categories: "Issue categories",
    acc: "issue category",
    alert: genericAlert,
  },
  task: {
    task: "Task",
    tasks: "Tasks",
    acc: "task",
    alert: genericAlert,
    label: {
      range: "Range",
      time: "Time",
      plan_start: "Planned from",
      plan_end: "Planned to",
      resource: "Resource",
      resources: "Resources",
      relation: "Relation",
      person: "Assigned person",
      type: "Task type",
      approve: "Approve",
      disapprove: "Disapprove",
      done: "Mark as done",
      undone: "Mark as undone",
      status: "Status",
      begin: "Begin",
      close: "Close",
      opinion: "Opinion",
      waiting: "Waiting",
      resume: "Resume",
      reopen: "Reopen",
      display_all: "Display all tasks",
      close_task: "Close task",
      description: "Task description:",
      asset_checklist: "Checklist",
      task_checklist: "Checklist",
      work_reports_count: "Work reports count",
      inform_requester: "Send to requester by email to {email}",
    },
    statuses: {
      inactive: "Inactive",
      new: "New",
      in_progress: "In progress",
      done: "Done",
      undone: "Undone",
      in_approval: "In approval",
      waiting: "Waiting",
      approved: "Approved",
      unapproved: "Unapproved",
    },
  },
  task_template: {
    task_template: "Task template",
    task_templates: "Task templates",
    acc: "task template",
    alert: genericAlert,
    label: {
      task_type: "Task type",
      task_types: "Task types",
      general: "General",
      approval: "Approval",
      in: "Receipt at the warehouse",
      out: "Expenditure from the warehouse",
      transfer: "Moving between warehouses",
      asset_checklist: "Asset checklist",
      task_checklist: "Task checklist",
      task_status: "Task status",
      issue_status: "Issue status",
      task_resolver_type: "Task resolver type",
      previous_task_completed: "Start after tasks are completed",
      task_chain: "Tasks Chain",
    },
    validation: {
      task_cycle_detected:
        "Circular  of tasks detected. Please remove dependencies that would create a cycle.",
      self_task: "A task cannot depend on itself.",
    },
    warnings: {
      cycle_detected:
        "Warning: This task selection may create circular dependencies.",
    },
    execution: {
      will_start_after: "will start after",
      parallel_tasks: "These tasks can run in parallel.",
      sequential_task: "This task must complete first.",
      sequential_task_chain:
        "These tasks form a sequential chain and must execute in order.",
    },
    task_resolver_types: {
      user: "User",
      team: "Team",
      team_owner: "Team owner",
      service_owner: "Service owner",
      issue_author: "Author of the issue",
      responsible_user: "Assigned person of the issue",
      reporter: "Reporter of the issue",
    },
  },
  task_user: {
    task_user: "User to task assignment",
    task_users: "Users to tasks assignments",
    acc: "user to task assignment",
    alert: genericAlert,
  },
  kpi: {
    kpi: "KPI",
    kpis: "KPI",
    acc: "KPI",
    alert: genericAlert,
    label: {
      computed_at: "Computed at",
      refresh_rate: "Refresh rate",
      data: "Data",
      definition: "Definition",
      preview: "Preview",
      visualization: "Visualization",
      calculation: "Calculation",
      key: "Option",
      value: "Value",
      next: "Next",
      back: "Back",
      legend: "Legend",
      count: "Count",
      no_issues: "No Issues",
      error: "Error computing KPI",
      no_data: "No data. Check options",
      submenu: {
        compute_now: "Compute now",
      },
      team_kpi: "Team KPI",
    },
    refresh_rates: {
      0: "None",
      60: "1 Hour",
      360: "6 Hours",
      1440: "24 Hours",
    },
    visualizations: {
      map: "Map",
      pie_chart: "Pie chart",
      donut_chart: "Donut chart",
      column_chart: "Column chart",
      bar_chart: "Bar chart",
      line_chart: "Line chart",
      area_chart: "Area chart",
      time_line: "Time line",
      stacked_column_chart: "Stacked column chart",
      stacked_bar_chart: "Stacked bar chart",
      table: "Table",
    },
    calculations: {
      ratio: "Ratio",
      average: "Average @.lower:form.label.feedback_rating",
      issue_count: "Issue count",
      sla_count: "SLA count",
      risk_count: "Risk count",
      sla_overview: "SLA overview",
      time_series: "Time series",
      detail_sum: "Sum by field in detail",
      map: "Map",
      map_colored: "Map by priority",
      transaction_item_sum: "Sum of transaction items",
    },
    display_type: {
      percentage: "Percentage",
      value: "Value",
      label: "Label",
      none: "No display",
    },
  },
  connector: {
    connector: "Connector",
    connectors: "Connectors",
    acc: "connector",
    alert: genericAlert,
    label: {
      type: "Type",
      status: "Status",
      on: "Turned on",
      connector_type: "Connector type",
      login: "Login",
      url: "URL",
      queries: "Queries definition",
      mail_receiver: {
        host: "Host",
        imap_port: "IMAP port",
        smtp_port: "SMTP port",
        user_name: "User name",
      },
      mail_ms_graph: {
        tenant_id: "Tenant ID",
        client_id: "Client ID",
        mailbox: "Mailbox",
        folders: "Folders",
        filter: "Filter",
        additional_bcc: "Additional Bcc address",
      },
      ldap: {
        port: "Port",
        bases: "Directories",
        filter: "Filter",
        attributes: "Attributes",
      },
      ftp: {
        path: "Path to source directory",
      },
      without: "Without connector",
    },
    type: {
      mail_receiver: "IMAP",
      mail_ms_graph: "MS Graph email",
      ldap: "LDAP",
      ftp: "FTP download",
      ftp_sender: "FTP upload",
      sftp: "SFTP download",
      sftp_sender: "SFTP upload",
      ca_sdm: "CA SDM REST",
      dpd_sap: "DPD SAP REST",
      document_saver: "Document saver",
      qualys: "Qualys",
      sccm: "SCCM",
      jira: "Jira",
      ausemio: "AUSEMIO",
      otrs: "OTRS",
    },
  },
  connector_run: {
    connector_run: "Run",
    connector_runs: "Runs",
    acc: "run",
    alert: genericAlert,
  },
  connector_result: {
    connector_result: "Connector result",
    connector_results: "Connector results",
    acc: "connector result",
    alert: genericAlert,
  },
  mapper: {
    mapper: "Mapper",
    mappers: "Mappers",
    acc: "mapper",
    alert: genericAlert,
    label: {
      mapper_type: "Mapper type",
      definition: "Definition",
    },
    mapper_types: {
      mail_receiver_mapper: "Issues from email",
      csv_mapper: "CSV -> assets/persons/issues",
      csv_generator: "Assets/persons/issues -> CSV",
      json_mapper: "JSON -> assets/persons",
      viskb_xml_generator: "Assets -> VISKB XML",
    },
  },
  external_email: {
    external_email: "External email",
    external_emails: "External emails",
    acc: "external email",
    alert: genericAlert,
    label: {
      submenu: {},
    },
  },
  permission: {
    permission: "Permission",
    permissions: "Permissions",
    acc: "permission",
    selection: "Object type",
    selectTypeAndUser: "Select object type and user",
    tooltip: {
      see: "See",
      create: "Create",
      update: "Update",
      destroy: "Delete",
      see_in_object: "See in object",
      update_in_object: "Update in object",
      see_issues: "See issues",
    },
    menu: {
      unset: "Not set",
      unchanged: "Not changed",
      allowObject: "Allowed ",
      allowObjectAndChildren: "Allowed with inheritance",
      denyObject: "Denied",
      denyObjectAndChildren: "Denied with inheritance",
    },
    label: {
      type: "Type",
      permitted_persons: "Permitted persons",
      persons_text_1: "Person",
      persons_text_2: "and all children in organization structure.",
      roles_text_1: "All persons assigned to role",
      assignee: "(Permission from assigned)",
      detail: "Permission detail",
      multiple_setup: "Setup for selected",
      entity: "Object",
      owner: "Permission owner",
    },
  },
  role: {
    role: "Role",
    roles: "Roles",
    acc: "role",
    alert: genericAlert,
    label: {
      configuration: "Configuration",
    },
  },
  team: {
    team: "Team",
    teams: "Teams",
    acc: "team",
    alert: genericAlert,
  },
  user: {
    user: "User",
    users: "Users",
    acc: "user",
    alert: genericAlert,
    label: {
      block_status: "Blocked",
      two_factor_auth: "Two factor authentication",
      status: "Status",
      is_turned_on: " is turned on",
      turn_on: "Turn on",
      is_turned_off: " is turned off",
      turn_off: "Turn off",
      turn_2fa_off: "Turn off two factor authentication",
      confirm: "Confirm",
      two_factor_auth_label:
        "Scan this QR code with two factor authentication mobile app. Enter generated code and confirm.",
      submenu: {
        resend_instructions: "Send recovery instructions",
      },
      hint: {
        roles: "Select roles that belongs to user",
        teams: "Select teams that belongs to user",
      },
      impersonate: "Impersonate user",
      phone: "Phone number",
      user_tree: "User tree",
    },
    tier_types: {
      implementer: "Implementer",
      admin: "Admin",
      full: "Full access",
      limited: "Limited access",
      technical: "Technical access",
    },
  },
  asset_category: {
    asset_category: "Asset category",
    asset_categories: "Asset categories",
    acc: "category",
    alert: genericAlert,
  },
  person_category: {
    person_category: "Person category",
    person_categories: "Person categories",
    acc: "category",
    alert: genericAlert,
  },
  category: {
    category: "Category",
    categories: "Categories",
    acc: "category",
    alert: genericAlert,
    label: {
      parents: "Parent categories",
      icon: "Icon",
      persons: "Persons",
      organization: "Organization",
      basic: "Basic",
      buildings: "Buildings",
      security: "Security",
      cars: "Cars",
      ikt: "Information and communication technologies",
      cyber_sec: "Cyber security",
      energetics: "Energetics",
      use_in_risk_management: "Use in risk management like",
      submenu: {
        new_cat: "Create new category",
        existing_cat: "Add existing category",
      },
    },
  },
  template: {
    template: "Template",
    templates: "Templates",
    acc: "template",
    alert: genericAlert,
    detail: "Detail",
    empty: "Can't display detail on object",
    raw: "Raw data",
    name: "Template name",
    label: {
      definition: "Definition",
      key: "Key",
      type: "Type",
      templates_on_categories: "Templates on person/asset categories",
      uniqueLastValue: "Max value",
      yes: "Yes",
      no: "No",
      field: "Field",
      data_type: "Data type",
      new_field: "New field",
      new_option: "New option",
      form: "Form",
      required: "Required",
      unique: "Unique",
      personal: "Personal data",
      notify: "Notify",
      submenu: {},
      fields: "Fields",
      multiselect: "Multiselect",
      conditional: "Turn on conditional selection",
      select_from: "Conditional on selection from",
      option: "Option",
      show_on_public_page: "Public issue",
      show_on_public_map: "Public map",
      full_user_only: "Not visible to limited users",
    },
  },
  field: {
    field: "Field",
    fields: "Fields",
    acc: "field",
    alert: genericAlert,
    label: {
      data_type: "Data type",
      hint: "Hint when filling out",
    },
    data_types: {
      String: "String",
      Text: "Text",
      Integer: "Number",
      Date: "Date",
      Time: "Time",
      Boolean: "Checkbox",
      Switch: "Switch",
      Select: "Select",
      Radio: "Radio",
      Document: "Document",
      Person: "Person",
      Asset: "Asset",
      Issue: "Issue",
      Password: "Password",
      DateTime: "Date and time",
    },
  },
  field_assignment: {
    field_assignment: "Field assignment",
    field_assignments: "Field assignments",
    acc: "field assignment",
    alert: genericAlert,
  },
  price_item: {
    price_item: "Item",
    price_items: "Items",
    acc: "item",
    label: {
      price_type: "Item type",
      unit: "Unit",
      base: "Base item",
      quantity: "Quantity",
      price: "Price",
      batch: "Batch",
      batches: "Batches",
      gtin: "GTIN",
      code_1: "Code 1",
      code_2: "Code 2",
      submenu: {},
    },
    price_types: {
      material: "Material",
      work: "Work",
      transport: "Transport",
    },
    batch: {
      dialog: {
        header: "Batch list",
      },
      name: "Batch name",
      expiration: "Expiration date",
      quantity: "Quantity",
      warehouse_quantity: "In stock",
      alert: "In warehouse are items with sooner expiration",
    },
    units: {
      // weight
      grams: "grams",
      kilograms: "kilograms",
      tons: "tons",
      ounces: "ounces",
      pounds: "pounds",
      // length
      millimeters: "millimeters",
      centimeters: "centimeters",
      meters: "meters",
      kilometers: "kilometers",
      feet: "feet",
      miles: "miles",
      // area
      square_meters: "square meters",
      ares: "ares",
      hectares: "hectares",
      square_feet: "square feet",
      acres: "acres",
      // volume
      milliliters: "milliliters",
      liters: "liters",
      hectoliters: "hectoliters",
      cubic_meters: "cubic meters",
      pints: "pints",
      gallons: "gallons",
      // time
      seconds: "seconds",
      minutes: "minutes",
      hours: "hours",
      days: "days",
      weeks: "weeks",
      months: "months",
      years: "years",
      // IT
      megabytes: "megabytes",
      gigabytes: "gigabytes",
      terabytes: "terabytes",
      // electric
      kilowatt_hours: "kilowatt hours",
      milli_ampere_hours: "milli ampere hours",
      // other
      pieces: "pieces",
      packages: "packages",
      pallets: "pallets",
      executions: "executions",
      man_hours: "man hours",
      engine_hours: "engine hours",
      man_days: "man days",
    },
    units_short: {
      // weight
      grams: "g",
      kilograms: "kg",
      tons: "t",
      ounces: "oz",
      pounds: "lb",
      // length
      millimeters: "mm",
      centimeters: "cm",
      meters: "m",
      kilometers: "km",
      feet: "ft",
      miles: "mi",
      // area
      square_meters: "m²",
      ares: "ar",
      hectares: "ha",
      square_feet: "ft²",
      acres: "acre",
      // volume
      milliliters: "ml",
      liters: "l",
      hectoliters: "hl",
      cubic_meters: "m³",
      pints: "pt",
      gallons: "gal",
      // time
      seconds: "s",
      minutes: "min",
      hours: "hr",
      days: "d",
      weeks: "w",
      months: "mon",
      years: "yr",
      // IT
      megabytes: "MB",
      gigabytes: "GB",
      terabytes: "TB",
      // electric
      kilowatt_hours: "kWh",
      milli_ampere_hours: "mAh",
      // other
      pieces: "pc",
      packages: "pkg",
      pallets: "pal",
      executions: "exec",
      man_hours: "man hr",
      engine_hours: "engine hr",
      man_days: "man day",
    },
    alert: genericAlert,
  },
  price_items_price_list: {
    price_items_price_list: "Price list item",
    price_items_price_lists: "Price list items",
    acc: "price list item",
    alert: genericAlert,
  },
  warehouse: {
    warehouse: "Warehouse",
    warehouses: "Warehouses",
    acc: "warehouse",
    alert: genericAlert,
    label: {
      balance: "Balance",
      quantity: "Quantity",
      warehouse_from: "Warehouse from",
      warehouse_to: "Warehouse to",
      price_summary: "Price summary",
      min: "Min.",
      opt: "Opt.",
      minimal: "Minimal balance",
      optimal: "Optimal balance",
      under_limit: "Under minimum quantity",
      warehouse_transactions: "Transactions",
      transaction_type: "Type",
      changed_at: "Changed at",
      transfer_to: "Transfer to other warehouse",
      status: "State",
      submenu: {
        make_transaction: "Edit balance",
      },
      transactions: {
        in: "Receipt",
        out: "Expense",
        transfer: "Transfer",
        transfer_from: "Transfer from warehouse",
        transfer_to: "Transfer to warehouse",
      },
      statuses: {
        pending: "Pending",
        closed: "Closed",
      },
    },
    dialog: {
      limit_header: "Setting limits",
      start: "Start scanning items",
      scanner_header: "Item scanner",
      add_manually: "Add item manually",
      manual_header: "Adding item",
    },
    messages: {
      transactionError: "Edit at least one item",
    },
  },
  price_list: {
    price_list: "Price list",
    price_lists: "Price lists",
    acc: "price list",
    alert: genericAlert,
    label: {
      price: "Price",
      prices: "Prices",
      unit_price: "Unit price",
      currency: "Currency",
      valid_from: "Valid from",
      valid_to: "Valid to",
      submenu: {
        setup_prices: "Setup prices",
      },
    },
  },
  work_report: {
    work_report: "Work report",
    work_reports: "Work reports",
    acc: "work report",
    alert: genericAlert,
    label: {
      price_list: "Price list used: ",
      quantity: "Quantity",
      object: "Warehouse / Person / Asset",
      author: "Author",
      summary: "Summary of resources with cost",
      items: "All work report on issue",
      total_price: "Total price",
      submenu: {},
      type: "Report type",
    },
  },
  checklist: {
    checklist: "Checklist",
    checklists: "Checklists",
    acc: "checklist",
    alert: genericAlert,
  },
  template_assignment: {
    template_assignment: "Template to object assignment",
    template_assignments: "Templates to objects assignments",
    acc: "template to object assignment",
    alert: genericAlert,
    label: {
      edit_header: "Template assignment",
      status: "Template validation on transition to status",
    },
    usage: "Usage",
  },
  dashboard_screen: {
    dashboard_screen: "Dashboard",
    dashboard_screens: "Dashboards",
    acc: "dashboard",
    new_dashboard: "New dashboard",
    refresh_rates: {
      0: "None",
      1: "1 Minute",
      5: "5 Minutes",
      15: "15 Minutes",
    },
    alert: genericAlert,
    label: {
      refresh_rate: "Refresh rate",
      team_dashboard: "Team dashboard",
    },
  },
  dashlet: {
    dashlet: "Dashlet",
    dashlets: "Dashlets",
    acc: "dashlet",
    alert: genericAlert,
    label: {
      order: "Order",
      size: "Width",
      setup_error: "Dashlet not setup",
    },
    sizes: {
      2: "16 %",
      3: "25 %",
      4: "33 %",
      6: "50 %",
      8: "66 %",
      9: "75 %",
      12: "100 %",
    },
  },
  subscription: {
    subscription: "Subscription",
    subscriptions: "Subscriptions",
    acc: "subscription",
    alert: genericAlert,
    label: {
      subscription_type: "Subscription type",
      subscribed_items: "Subscribed items",
      type: "Type",
      last_one: "At least one option must be selected",
      issue_priority: "At what priority?",
    },
    subscription_types: {
      Service: "Services",
      Contract: "Contracts",
      Rule: "Rules",
      Asset: "Assets",
      AssetCategory: "Asset categories",
      Person: "Persons",
      PersonCategory: "Person categories",
      Warehouse: "Warehouses",
      PriceItem: "Price items",
      Connector: "Connectors",
      Mapper: "Mappers",
      AutomatedAction: "Automated actions",
      Other: "Other",
    },
  },
  entity_subscription: {
    entity_subscription: "Subscribed object",
    acc: "subscribed object",
    alert: genericAlert,
  },
  notification: {
    notification: "Notification",
    notifications: "Notifications",
    acc: "notification",
    alert: genericAlert,
    label: {
      empty: "You have no unread notifications",
      from: "From",
      mark_as_read: "Mark as read",
      open_object: "Go to this object",
      notifications_list: "Notifications list",
      on_object: "on object",
      read: "Read",
      read_all: "Mark all as read",
      view_all: "View all",
      created: "Created",
      notification_send_when: "Notification will be sent",
      when: "When you want to be notified?",
      how: "How you want to be notified?",
      time: "Time",
      before_expire: "Notification time before expiration",
      before_batch_expire: "Notification time before batch expiration",
      before_notice_period: "Notification time before the notice period begins",
    },
    types: {
      issue_create: "When issue is created",
      issue_close: "When issue is closed",
      update: "When the object is updated",
      fail: "When the connector fails",
      mention: "When I'm mentioned in the note on issue",
      note_create: "When new note on issue is created",
      assign: "When I'm assigned to issue",
      assign_to_task: "When I'm assigned to task",
      team_issue: "When issue is created for my team",
      team_task: "When task is assigned to my team",
      unassigned_task:
        "When there is active task without assignee on issue I am responsible for",
      expire: "When it expires",
      prolong: "When it is prolonged",
      before_notice_period: "Before the notice period begins",
      before_expire: "Before it expires",
      optimal_balance: "When the optimal count is exceeded",
      minimal_balance: "When the minimal count is exceeded",
      before_batch_expire: "Before batch expiration",
      batch_expire: "When the batch expires",
      response_time_expire: "When reaction time ends",
      before_response_time_expire: "Before reaction time ends",
      resolution_time_expire: "When resolution time ends",
      before_resolution_time_expire: "Before resolution time ends",
      issue_state_enter: "In a specific state",
      run_error: "When a run error occurs",
      my_issue_resolve: "When my issue is resolved",
      my_issue_close: "When my issue is closed",
      my_issue_note_create: "When a new note is created on my issue",
      assigned_issue_note_create:
        "When a new note is created on issue I am responsible for",
      only_issue_author:
        "Only if the note is created by the author of the issue",
      assigned_issue_note_create_only_issue_author:
        "When a new note is created on issue I am responsible for by the author of the issue",
    },
    tooltip: {
      mail: "Notification by email",
      push: "Push notification",
      sms: "SMS notification",
    },
  },
  snippet: {
    snippet: "Snippet",
    snippets: "Snippets",
    acc: "snippet",
    alert: genericAlert,
    label: {
      value: "Value",
      team_snippet: "Team snippet",
    },
  },
  entity_document: {
    entity_document: "Link to document",
    entity_documents: "Links to documents",
    acc: "link to document",
    dialog: {
      from_document: "Link objects",
      from_entity: "Link documents",
      hint: "Start typing to search",
    },
    alert: genericAlert,
  },
  location: {
    location: "Location",
    locations: "Locations",
    acc: "location",
    alert: genericAlert,
    label: {
      longitude: "Longitude",
      latitude: "Latitude",
      loadName: "Load name",
      layers: "Layers",
      cadastre: "Cadastre",
      basic: "Basic",
      public_issue_map: "Issue map",
      current: "Load current location",
    },
    tooltip: {
      getCoordinates: "Get coordinates by place name",
      disabled: {
        getCoordinates: "Type full place name",
        current: "Access to the location was denied",
      },
    },
    hint: {
      latitude: "Enter in decimal format",
      longitude: "Enter in decimal format",
    },
    select_location: "Click on the map to change the location",
  },
  issue_note: {
    issue_note: "Note",
    issue_notes: "Notes",
    acc: "note",
    alert: genericAlert,
    note_types: {
      internal: "Internal",
      public: "Public",
      solution: "Solution",
      external: "External",
      description: "Description",
    },
    label: {
      from: "From: ",
      displaying: "Displaying",
      send_email: "Send via mail",
      email_to: "To",
      email_cc: "Copy",
      email_bcc: "Hidden copy",
      loadMore: "Load more",
      note_type: "Note type",
      linkCopied: "Link to note was copied",
      new: "New Note",
      forward: "Forward {type} note",
      response: "Response",
      reply: "Reply to {type} note",
      reply_to_all_emails: "Reply to all emails",
    },
    previous_note: "Previous note",
    hint: {
      note: "Apply snippets by character *. Apply object mentions by character @ for persons, $ for assets, % for documents a # for issues.",
    },
  },
  issue_feedback: {
    issue_feedback: "Feedback",
    issue_feedbacks: "Feedbacks",
    acc: "feedback",
    alert: genericAlert,
  },
  issue_link: {
    issue_link: "Linked issue",
    issue_links: "Linked issues",
    acc: "linked issue",
    alert: genericAlert,
    label: {
      type: "Type",
    },
    link_types: {
      related: "Related issues",
      duplicate: "Duplicate",
    },
  },
  assets_issue: {
    assets_issue: "Asset on issue",
    assets_issues: "Assets on issues",
    acc: "asset to issue assignment",
    issue: "Asset assigned to issue",
    asset: "Issue assigned to asset",
    alert: genericAlert,
    label: {
      solve_status: "Solving status",
      not_run: "Not run",
      success: "Success",
      fail: "Fail",
      warning: "Warning",
    },
  },
  role_user: {
    role_user: "User to role assignment",
    role_users: "Users to roles assignments",
    acc: "user to role assignment",
    alert: genericAlert,
    label: {
      person_setup: "Set persons for role",
    },
  },
  team_user: {
    team_user: "User to team assignment",
    team_users: "Users to teams assignments",
    acc: "user to team assignment",
    alert: genericAlert,
    label: {
      person_setup: "Set persons for team",
    },
  },
  person_asset: {
    person_asset: "Person to asset assignment",
    person_assets: "Persons to assets assignments",
    acc: "person to asset assignment",
    alert: genericAlert,
  },
  external_guid: {
    external_guid: "Identifier",
    external_guids: "Identifiers",
    acc: "identifier",
    alert: genericAlert,
    bar: "BAR code",
  },
  jwt_session: {
    jwt_session: "Connected device",
    jwt_sessions: "Connected devices",
    acc: "connected device",
    alert: genericAlert,
    label: {
      actual: "Actual session",
      browser: "Browser",
      last_ip: "Last IP adress",
      location: "Location",
    },
  },
  tag_definition: {
    tag_definition: "Tag",
    tag_definitions: "Tags",
    acc: "tag",
    alert: genericAlert,
    label: {
      color: "Color",
      without: "Without tag",
      add: "Add tag",
      new: "Create new tag",
      filter: "Filter",
    },
  },
  issue_priority: {
    issue_priority: "Issue priority",
    issue_priorities: "Issue priorities",
    acc: "issue priority",
    alert: genericAlert,
    label: {
      priority: "Priority",
      order: "Order",
      without: "Without priority",
    },
  },
  person_relation: {
    person_relation: "Person relation",
    person_relations: "Person relations",
    acc: "person relation",
    alert: genericAlert,
  },
  profile: {
    profile: "Profile",
    profiles: "Profiles",
    acc: "profile",
    settings: "Settings",
    alert: genericAlert,
    email: "Email",
    change_email: "Change",
    password: "Password",
    change_password: "Change",
    password_current: "Enter your current password",
    password_new: "New password",
    password_new_c: "Confirm new password",
    account: "Account",
    account_security: "Account Security",
    manage_settings: "Manage your account settings and preferences",
    preferences: "Preferences",
    prefer_exact_dates: "Prefer exact dates",
    theme: "Theme",
    theme_options: {
      use_system_theme: "According to system",
      dark: "Dark",
      light: "Light",
    },
    locale: "Language",
    date_format: "Date format",
    time_format: "Time format",
    time_zone: "Time zone",
    week_first_day: "First day of week",
    pagination: "Pagination",
    home_page: "Home page",
    two_factor_auth: "Two factor authentication",
    devices: "Devices",
    about: "About",
    change_to_ssp: "Switch to Self Service Portal",
    change_from_ssp: "Switch to Main application",
    product: {
      more_1:
        "You can find more about the AUSEMIO platform and the licensing at {web}, where you will find business contacts.",
      more_2: "In case of technical questions, contact us at {mail}.",
      legal: {
        cookies: "Cookies",
        gdpr: "Data Processing",
      },
      install: {
        name: "Name",
        id: "Identifier",
        version: "Version",
        administration: "Administrator",
      },
    },
  },
  license: {
    license: "License",
    label: {
      type: "User type",
      monthly: "Monthly",
      yearly: "Yearly",
    },
    items: {
      title: "License",
      payment: "Payment",
      users: "Users",
      storage: "Storage",
      connectors: "Connectors",
      of: "of",
      modules: "Modules",
    },
  },
  administration: {
    administration: "Administration",
    administrations: "Administrations",
    acc: "administration",
    alert: genericAlert,
  },
  import: {
    import: "Import",
    imports: "Import",
    acc: "import",
    alert: genericAlert,
    label: {
      link_to: "Link document to",
      export_question: "Do you want to export {model}?",
      export_text: "Filtered {model} will be exported in .xlsx format",
      custom_export_text: "{model} will be exported in .xlsx format",
      failed_row_number: "Failed row number",
      failed_message: "Fail message",
      operation: "Operation",
      status: "Status",
      stop: "Stop import",
    },
  },
  implementation: {
    implementation: "Implementation",
    implementations: "Implementations",
    acc: "implementation",
    alert: genericAlert,
    smtp: {
      label: {
        address: "Address",
        authentication: "Authentication",
        domain: "Domain",
        host: "Host",
        openssl: "Open SSL verify mode",
        port: "Port",
        starttls: "Enable STARTTLS",
        tls: "TLS",
        user_name: "User name",
      },
    },
    menu: {
      notice: "Notice",
      calendar: "Calendar",
      statistics: "Statistics",
      mail_server: "Email server",
      issue_state_transitions: "Issue state transitions",
      user_settings: "Default user settings",
      document_settings: "Document settings",
      new_passwd: "Set up new password",
      public_form: "Public issue form",
      background_jobs: "Background jobs",
      app_settings: "App settings",
      installation: "Installation",
      holidays: "Holidays",
      branding: "Branding",
      ssp_settings: "Self service portal settings",
    },
    label: {
      // issue states and priorities dialog
      color: "Color",
      db_representation: "Database representation",
      max_filesize: "Max file size in MB",
      compress_dimension: "Max image compress dimension in px",
      notice: "Notice",
      severity: "Severity",
      setup_notice: "Setup notice",
      category: "Select category to generate import script",
      generate: "Generate XLSX file",
      read_file: "Read import file",
      run_import: "Run import",
      new_import: "New import",
      hide_table: "Hide table (recommended when processing 100 and more rows)",
      public_form: {
        form: "Whole public issue form",
        step_2: "Step 2 (QR code scanning)",
        step_3: "Step 3 (location)",
      },
      severity_levels: {
        info: "Info",
        error: "Error",
        warning: "Warning",
        success: "Success",
      },
      ssp: {
        title: "Portal header",
        subtitle: "Portal subtitle",
      },
      documents: {
        person_documents: "Person documents",
        person_avatars: "Person avatars",
        person_detail: "Person detail",
        person_reports: "Person reports",
        asset_documents: "Asset documents",
        asset_avatars: "Asset avatars",
        asset_detail: "Asset detail",
        asset_reports: "Asset reports",
        asset_checklists: "Asset checklists",
        contract_documents: "Contract documents",
        service_documents: "Service documents",
        rule_documents: "Rule documents",
        issue_documents: "Issue documents",
        issue_detail: "Issue detail",
        issue_reports: "Issue reports",
        audit_documents: "Audit documents",
        audit_evidences: "Audit evidence",
        audit_reports: "Audit reports",
        price_list_reports: "Price list reports",
        default_folder_settings: "Default file save settings for:",
      },
      default_email_connector: "Default email connector",
    },
    hint: {
      documents_import: {
        filters: "Documents will be linked to filtered objects",
      },
    },
  },
  notice: {
    notice: "Notice",
    acc: "notice",
    alert: genericAlert,
  },
  activity: {
    activity: "Activity",
    activities: "Activities",
    acc: "activity",
    label: {
      activity_type: "Activity type",
      author_type: "Author type",
      changed: "Changed",
      changed_at: "Changed at",
      changed_by: "Changed by",
      from: "From",
      to: "To",
      diff: "Differences",
      attribute: "Attribute",
    },
    list_label: {
      created_at: "Created at",
      created_by: "Created by",
      activity_type: "Activity type",
      object_type: "Object type",
      object_id: "Object ID",
      name: "Name",
      before: "Before",
      after: "After",
    },
    activity_types: {
      create: "Create",
      update: "Update",
      destroy: "Destroy",
      log_in: "Log In",
      log_out: "Log Out",
      other: "Other",
      archive: "Archive",
      unarchive: "Unarchive",
    },
    timeline: {
      chips: {
        Issue: "@:issue.issue",
        TagAssignment: "@:tag_definition.tag_definitions",
        EntityDocument: "@:document.documents",
        IssueNote: "@:issue_note.issue_notes",
        IssueFeedback: "@:issue_feedback.issue_feedback",
        AssetsIssue_issue: "@:asset.assets",
        WorkReport: "@:work_report.work_reports",
        Location: "@:location.location",
        IssueLink: "@:issue_link.issue_links",
        Asset: "@:asset.asset",
        PersonAsset: "@:person.persons",
        AssetsIssue_asset: "@:issue.issues",
        ExternalGuid: "@:external_guid.external_guid",
        IssueService: "@:issue_service.issue_service",
      },
      Issue: {
        create: "created this",
        update: "edited this",
        destroy: "deleted this",
        status_change: "changed state to",
      },
      Asset: {
        create: "created this",
        update: "edited this",
        destroy: "deleted this",
        archive: "archived this",
        unarchive: "unarchived this",
      },
      AssetsIssue: {
        create: "assigned asset to issue",
        update: "edited asset on issue",
        destroy: "removed asset from issue",
      },
      IssueService: {
        create: "assigned issue to service",
        update: "edited issue",
        destroy: "removed issue from service",
      },
      IssueLink: {
        create: "assigned",
        update: "edited",
        destroy: "deleted",
      },
      EntityDocument: {
        create: "assigned",
        update: "edited",
        destroy: "removed",
      },
      PersonAsset: {
        create: "assigned",
        update: "edited",
        destroy: "removed",
      },
      WorkReport: {
        create: "assigned",
        update: "edited",
        destroy: "removed",
      },
      ExternalGuid: {
        create: "assigned",
        update: "edited",
        destroy: "removed",
      },
      Location: {
        create: "assigned",
        update: "edited",
        destroy: "removed",
      },
      IssueNote: {
        create: "added",
        update: "edited",
        destroy: "removed",
      },
      IssueFeedback: {
        create: "added",
        destroy: "removed",
      },
      TagAssignment: {
        create: "assigned",
        update: "edited",
        destroy: "removed",
      },
      generic: {
        Issue: "issue",
        Asset: "asset",
        IssueLink: "link to issue",
        AssetsIssue: "",
        IssueService: "",
        IssueNote: "note",
        IssueFeedback: "feedback",
        WorkReport: "work report",
        EntityDocument: "document",
        PersonAsset: "person",
        ExternalGuid: "identifier",
        Location: "location",
        TagAssignment: "tag",
      },
    },
  },
  filter: {
    filter: "Filter",
    filters: "Filters",
    acc: "filter",
    alert: genericAlert,
    existence_levels: {
      all: "All",
      archived: "Only archived",
    },
    issue_closed_levels: {
      all: "All",
      closed: "Only closed",
    },
    otp_required_for_login_levels: {
      two_factor_auth: "2FA",
      without_two_factor_auth: "Without 2FA",
    },
    blocked_levels: {
      blocked: "Blocked",
      not_blocked: "Not blocked",
    },
    on_levels: {
      on: "Enabled",
      off: "Disabled",
    },
    public_token_valid_levels: {
      public: "Public",
      internal: "Internal",
    },
    below_min_levels: {
      below: "Below minimum",
      above: "Above minimum",
    },
    above_opt_levels: {
      below: "Below optimum",
      above: "Above optimum",
    },
    with_user_levels: {
      with_user: "With user",
      without_user: "Without user",
    },
    actions: {
      subheaders: {
        savedFilters: "Saved filters",
      },
    },
  },
  data_set: {
    data_set: "Filter",
    data_sets: "Filters",
    acc: "filter",
    alert: genericAlert,
    label: {
      target_entity: "Target data type",
      definition: "Definition",
      edit_filter_definition: "Edit filter definition",
      definition_from_filter: "Load definition from filter",
      edit_definition: "Edit definition",
    },
    target_entities: {
      Activity: "@:activity.activity",
      AppliedSla: "SLA",
      Asset: "@:asset.asset",
      AssetCategory: "@:asset_category.asset_category",
      AssetsIssue: "@:checklist.checklist",
      AutomatedAction: "@:automated_action.automated_action",
      Contract: "@:contract.contract",
      DataSet: "@:data_set.data_set",
      Document: "@:document.document",
      ExternalEmail: "@:external_email.external_email",
      Field: "@:field.field",
      Issue: "@:issue.issue",
      Kpi: "@:kpi.kpi",
      Person: "@:person.person",
      PersonCategory: "@:person_category.person_category",
      PriceItem: "@:price_item.price_item",
      PriceItemsWarehouse: "@:price_items_warehouse.price_items_warehouse",
      PriceList: "@:price_list.price_list",
      Report: "@:report.report",
      Requirement: "@:requirement.requirement",
      Risk: "@:risk.risk",
      Role: "@:role.role",
      Service: "@:service.service",
      Snippet: "@:snippet.snippet",
      Subscription: "@:subscription.subscription",
      Task: "@:task.task",
      Threat: "@:threat.threat",
      Translation: "@:translation.translation",
      User: "@:user.user",
      Vulnerability: "@:vulnerability.vulnerability",
      Warehouse: "@:warehouse.warehouse",
      WarehouseTransactionItem:
        "@:warehouse_transaction_item.warehouse_transaction_item",
    },
    multi_operations: {
      create_issue: "Create issue",
      link_to_document: "Link document",
      change_parent: "Change placement in tree",
      link_assets_to_person: "Link to person",
      link_persons_to_asset: "Link asset",
      link_documents_to_entity: "Link to object",
      compress_documents: "Compress images",
      tag: "Add tag",
      untag: "Remove tag",
      group: "Add to group",
      ungroup: "Remove from group",
      remove_assets_from_person: "Remove from person",
      archive_multiple: "Archive",
      destroy_multiple: "Delete",
      export: "Export",
      report: "Generate report",
    },
    multi_operations_hint: {
      generic:
        "Other operations cannot be run because you have filtered more than 1000 items.",
    },
  },
  report: {
    report: "Report",
    reports: "Reports",
    acc: "report",
    alert: genericAlert,
    label: {
      target_entity: "Target data type",
      report_type: "Report type",
      generate: "Generate",
      submenu: {
        generate_report: "Generate report",
        subheader: "Reports",
      },
      contains_qr: "Contains QR code",
      contains_avatar: "Contains avatar",
    },
    messages: {
      hint: "The report will be generated in the background and the file will be saved in the selected folder. You will be notified about completion by a notification in the application.",
    },
    report_types: {
      single_entity: "Single object",
      data_set: "Filter",
    },
    target_entities: {
      Issue: "@:issue.issue",
      Asset: "@:asset.asset",
      Person: "@:person.person",
      PriceList: "@:price_list.price_list",
      Audit: "@:audit.audit",
      Risk: "@:risk.risk",
    },
  },
  automated_action: {
    automated_action: "Automated action",
    automated_actions: "Automated actions",
    acc: "automated action",
    alert: genericAlert,
    label: {
      automated_action_type: "Automated action type",
      run_type: "Run type",
      definition: "Definition",
      edit_definition: "Edit definition",
      on: "Enabled",
      activity: "Action type",
      author_type: "Author type",
      recipient_type: "Recipient type",
      variable: "Variable",
    },
    stepper: {
      basic: "Basic settings",
      trigger: "Trigger",
      action: "Action",
    },
    automated_action_types: {
      notify: "Send notification",
      report: "Generate report",
      create: "Create object",
      update: "Update object",
      archive: "Archive object",
      destroy: "Destroy objects",
      run_connector: "Run connector",
    },
    run_types: {
      now: "Now",
      delayed: "Delayed",
    },
  },
  holiday: {
    holiday: "Holiday",
    holidays: "Holidays",
    acc: "holiday",
    alert: genericAlert,
    label: {
      country: "Country",
      date: "Date",
    },
  },
  sla: {
    sla: "SLA",
    slas: "SLA",
    acc: "SLA",
    alert: genericAlert,
    label: {
      states: "States",
      response_time: "Reaction time",
      resolution_time: "Resolution time",
      autoclose_time: "Automatically close resolved issues after",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wedensday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
      holiday: "Holiday",
      holidays_countries: "Countries for holidays",
      from: "From",
      to: "To",
      estimated_response_time: "Response - Limit by SLA",
      responded_at: "Response - Actual Time",
      estimated_resolution_time: "Resolution - Limit by SLA",
      resolved_at: "Resolution - Actual Time",
      response_status: "Response - Status",
      response: "Response",
      resolution_status: "Resolution - Status",
      resolution: "Resolution",
      nonstop: "Nonstop",
      standby: "Standby",
      before_time_runs_out: "before time runs out",
      set_sla_times: "Set SLA times",
      set_autoclose_time: "Set automatic closure of issues",
    },
    statuses: {
      in_progress: "In progress",
      overdue: "Overdue",
      resolved: "Resolved",
      paused: "Paused",
      in_progress_n: "In progress",
      overdue_n: "Overdue",
      resolved_n: "Resolved",
      paused_n: "Paused",
    },
    message_prefix: {
      future: "Will expire",
      now: "Expired",
    },
  },
  risk_management: {
    risk_management: "Risk management",
    acc: "risk management",
    alert: genericAlert,
  },
  vulnerability: {
    vulnerability: "Vulnerability",
    vulnerabilities: "Vulnerabilities",
    acc: "vulnerability",
    alert: genericAlert,
    label: {
      add: "Add vulnerability",
    },
  },
  threat: {
    threat: "Threat",
    threats: "Threats",
    acc: "threat",
    alert: genericAlert,
    label: {
      add: "Add threat",
      confidentiality: "Impact on confidentiality",
      integrity: "Impact on integrity",
      availability: "Impact on availability",
      accidental: "Accidental",
      intentional: "Intentional",
      environmental: "Environmental",
    },
  },
  threat_category: {
    threat_category: "Threat category",
    threat_categories: "Threat categories",
    acc: "threat category",
    alert: genericAlert,
  },
  consequence: {
    consequence: "Consequence",
    consequences: "Consequences",
    acc: "consequence",
    alert: genericAlert,
  },
  likelihood: {
    likelihood: "Likelihood",
    likelihoods: "Likelihoods",
    acc: "likelihood",
    alert: genericAlert,
  },
  risk_level: {
    risk_level: "Risk level",
    risk_levels: "Risk levels",
    acc: "risk level",
    alert: genericAlert,
    label: {
      color: "Color",
    },
  },
  risk: {
    risk: "Risk",
    risks: "Risks",
    acc: "risk",
    alert: genericAlert,
    label: {
      description: "Risk scenario",
      consequence: "Consequence",
      consequenceShort: "C",
      likelihood: "Likelihood",
      likelihoodShort: "L",
      risk: "Risk",
      riskShort: "R",
      not_rated: "Not Rated",
      network_graph: "Network Graph",
      effectiveness: "Effectiveness",
      real_effectiveness: "Real effectiveness",
      planned_effectiveness: "Planned effectiveness",
      reduction: "Control weight",
      current_risk: "Current risk",
      residual_risk: "Residual risk",
      treatment_kind: "Treatment plan",
      risk_analysis: "Risk analysis",
      risk_type: "Risk type",
      risk_matrix: "Risk matrix",
      show_all_controls: "Show all controls",
      show_zero_risks: "Show zero risks",
      generate_report: "Generate risk report",
    },
    treatment_kind: {
      null: "-",
      reduce: "Reduction",
      accept: "Acceptance",
      share: "Sharing",
    },
  },
  asset_group: {
    asset_group: "Asset group",
    asset_groups: "Asset groups",
    acc: "asset group",
    alert: genericAlert,
    label: {
      add: "Add asset group",
    },
  },
  asset_group_asset: {
    asset_group_asset: "Asset in asset group",
    asset_group_assets: "Assets in asset group",
    acc: "asset in asset group",
    alert: genericAlert,
  },
  risk_asset_group: {
    risk_asset_group: "Risk asset group",
    risk_asset_groups: "Risk asset groups",
    acc: "risk asset group",
    alert: genericAlert,
    label: {
      add: "Add risk asset group  ",
    },
  },
  risk_asset: {
    risk_asset: "Risk asset",
    risk_assets: "Risk assets",
    acc: "risk asset",
    alert: genericAlert,
    label: {
      add: "Add risk asset",
    },
  },
  asset_link: {
    asset_link: "Asset link",
    asset_links: "Asset links",
    acc: "asset link",
    alert: genericAlert,
  },
  asset_control: {
    asset_control: "Asset control assignment",
    asset_controls: "Asset control assignments",
    acc: "asset control assignment",
    alert: genericAlert,
  },
  control: {
    control: "Control",
    controls: "Controls",
    acc: "control",
    alert: genericAlert,
    label: {
      add: "Add control",
      applied: "Applied controls",
      applied_s: "Applied control",
      add_applied: "Add applied control",
      remove_applied: "Remove applied control",
      add_planned: "Add planned control",
      remove_planned: "Remove planned control",
      planned: "Planned controls",
      control: "1 control | {n} controls",
      note: "Note",
      budget: "Budget",
      time: "Time",
      deadline: "Deadline",
      accept: "I accept",
      warning_message:
        "When saved, the value of the applied control will be overwritten, and all other values will be deleted.",
      justification: "Justification",
      responsible_user: "Responsible user",
    },
  },
  controls_management: {
    controls_management: "Controls management",
  },
  audit: {
    audit: "Audit",
    audits: "Audits",
    acc: "audit",
    alert: genericAlert,
    label: {
      compliance: "Compliance",
      partial_compliance: "Partial compliance",
      non_compliance: "Non compliance",
      not_applicable: "Not applicable",
      unrated: "Unrated",
      auditor: "Auditor",
      audit_organization: "Audited organization",
      representative: "Representative of the organization",
      submission_date: "Date of submission",
      requirements: "Requirements",
      evidence: "Evidence",
      questions: "Questions",
      findings: "Answers",
      note: "Notes",
      copy_questions: "Copy questions",
    },
  },
  question: {
    question: "Question",
    questions: "Questions",
    acc: "question",
    alert: genericAlert,
    label: {
      question: "Question",
      finding: "Answer",
      note: "Note",
    },
  },
  provision_question: {
    provision_question: "Question",
    provision_questions: "Questions",
    acc: "question",
    alert: genericAlert,
  },
  standard_soa_provision: {
    standard_soa_provision: "Requirement",
    standard_soa_provisions: "Requirements",
    acc: "requirement",
    alert: genericAlert,
  },
  recommendation: {
    recommendation: "Recommended control",
    recommendations: "Recommended controls",
    acc: "recommended control",
    alert: genericAlert,
  },
  suggestion: {
    suggestion: "Suggestion",
    suggestions: "Suggestions",
    acc: "suggestion",
    alert: genericAlert,
  },
  standard: {
    standard: "Standard",
    standards: "Standards",
    acc: "standard",
    alert: genericAlert,
    laws_standards: "Standards",
    label: {
      label: "Label",
      text: "Text",
      valid_from: "Valid from",
      valid_to: "Valid to",
    },
  },
  standard_soa: {
    standard_soa: "Statement of Applicability",
    standard_soas: "Statements of Applicability",
    acc: "statement of Applicability",
    alert: genericAlert,
    label: {
      reason: "Reason",
      applicable: "Applicable",
    },
  },
  section: {
    section: "Section",
    sections: "Sections",
    acc: "section",
    alert: genericAlert,
  },
  provision: {
    provision: "Provision",
    provisions: "Provisions",
    acc: "provision",
    alert: genericAlert,
  },
  requirement: {
    requirement: "Requirement",
    requirements: "Requirements",
    acc: "requirement",
    alert: genericAlert,
    label: {
      status: "Status",
    },
  },
  evaluation: {
    evaluation: "Evaluation",
  },
  issue_tab: {
    redirect: "View in Issues",
  },
  warehouse_transaction: {
    warehouse_transaction: "Transaction",
    warehouse_transactions: "Transactions",
    acc: "transaction",
    alert: genericAlert,
    label: {
      transaction_type: "Transaction type",
    },
  },
  warehouse_transaction_item: {
    warehouse_transaction_item: "Transaction item",
    warehouse_transaction_items: "Transaction items",
    acc: "transaction item",
    alert: genericAlert,
  },
  warehouse_batch: {
    warehouse_batch: "Batch",
  },
  tag_assignment: {
    tag_assignment: "Tag assignment",
    alert: genericAlert,
    acc: "tag assignment",
  },
  price_items_warehouse: {
    price_items_warehouse: "Warehouse item",
    price_items_warehouses: "Warehouse items",
    acc: "warehouse item",
    alert: genericAlert,
  },
  price_list_item: {
    price_list_item: "Price list item",
  },
  category_hierarchy: {
    category_hierarchy: "Category hierarchy",
  },
  background_job: {
    background_job: "Background job",
    background_jobs: "Background jobs",
    acc: "background job",
    alert: genericAlert,
    label: {
      last_error: "Last Error",
    },
  },
  external_password: {
    external_password: "External password",
  },
  translation: {
    translation: "Translation",
    translations: "Translations",
    acc: "translation",
    alert: genericAlert,
    label: {
      key: "Key",
      en: "Translation EN",
      sk: "Translation SK",
      en_short: "EN",
      sk_short: "SK",
    },
  },
  cia: {
    cia: "CIA",
  },
  risk_control: {
    risk_control: "Control on risk",
    risk_controls: "Controls on risk",
    acc: "control on risk",
    alert: genericAlert,
  },
  issue_service: {
    issue_service: "Issue on service",
  },
  tiptap_editor: {
    bold: "Bold",
    italic: "Italic",
    strike: "Strikethrough",
    underline: "Underline",
    highlight: "Highlight",
    text_color: "Text Color",
    header_1: "Heading 1",
    header_2: "Heading 2",
    header_3: "Heading 3",
    bullet_list: "Bullet List",
    ordered_list: "Numbered List",
    align_left: "Left Align",
    align_center: "Center Align",
    align_right: "Right Align",
    table: "Insert Table",
    add_column_before: "Add Column Before",
    add_column_after: "Add Column After",
    delete_column: "Delete Column",
    add_row_before: "Add Row Before",
    add_row_after: "Add Row After",
    delete_row: "Delete Row",
    delete_table: "Delete Table",
    leave_table: "Leave Table",
    link: "Insert Link",
    image: "Insert Image",
    invalid_image_type: "Please select a valid image file.",
    mentions: "Mentions",
    placeholder: "Write something...",
    label: {
      link: "Link",
      link_text: "Link Text",
      link_url: "Link URL",
    },
    toggle_header_row: "Toggle header row",
  },
  knowledge_base: {
    knowledge_base: "Knowledge base",
    acc: "knowledge base",
    alert: genericAlert,
    pinned: "Pinned",
    recommended: "Recommended",
    search_results: "Search Results",
    recent_articles: "Recent Articles",
    no_results: "No articles found",
    no_context: "No context available",
    view_all: "View All",
    search_articles: "Search knowledge base articles",
    pin_to_object: "Pin to object",
    unpin_from_object: "Unpin from object",
    copy_link: "Copy article link",
    copy_article: "Copy article content",
    link_copied: "Article link copied to clipboard",
    article_copied: "Article content copied to clipboard",
    copy_failed: "Failed to copy to clipboard",
    article_pinned: "Article pinned successfully",
    article_unpinned: "Article unpinned successfully",
  },
  article: {
    article: "Article",
    articles: "Articles",
    acc: "article",
    alert: genericAlert,
    label: {
      title: "Title",
      content: "Content",
      type: "Type",
      keywords: "Keywords",
      author: "Author",
      created_at: "Created at",
      created_by: "Created by",
      published_by: "Published by",
      withdraw_article: "Withdraw article",
      updated_at: "Updated at",
      likes: "Likes",
      dislikes: "Dislikes",
      version: "Version",
      publish_article: "Publish article",
    },
    article_types: {
      faq: "FAQs",
      how_to: "Guides",
      troubleshooting: "Troubleshooting",
    },
    article_statuses: {
      draft: "Draft",
      published: "Published",
      archived: "Archived",
    },
  },
  article_pin: {
    article_pin: "Article pin",
    article_pins: "Article pins",
    acc: "article pin",
    alert: genericAlert,
  },
  link: {
    link: "Link",
    links: "Links",
    acc: "link",
    alert: genericAlert,
  },
  portal: {
    select_service: "Select a service to get detailed information",
    no_services: "No services available",
    open_issues: "Open Issues",
    new_issues: "New Issues",
    pending_approvals: "Pending Approvals",
    resolved_today: "Resolved Today",
    provided_services: "Provided Services",
    from_last_week: "from last week",
    available_to_you: "available to you",
    recent_activity: "Recent Activity",
    quick_actions: "Quick Actions",
    service_details: "Service Details",
    create_issue: "Create Issue",
    service_information: "Service Information",
    active: "Active",
    service_id: "Service ID",
    recent_issues: "Recent Issues",
    all_issues: "All Issues",
    no_recent_issues: "No recent issues found",
    view_all: "View All",
    show_less: "Show Less",
    view_all_open_issues: "View all open issues",
    view_pending_approvals: "View issues awaiting approval",
    view_resolved_today: "View issues resolved today",
    statistics: "Statistics of issues",
    new: "New",
    in_progress: "In Progress",
    resolved: "Resolved",
    closed: "Closed",
    quick_links: "Quick Links",
    create_new_issue: "Create New Issue",
    view_my_issues: "View My Issues",
    request_service: "Request Service",
    knowledge_base: "Knowledge Base",
    submit_new_request: "Submit New Request",
    view_all_issues: "View All Issues",
    service_documentation: "Service Documentation",
    contact_support: "Contact Support",
    view_details: "View Details",
    no_services_available:
      "No services are currently available. Please check back later.",
    popular_articles: "Most Popular Articles",
    helpful_resources: "Helpful Resources",
    no_notes: "No notes yet",
    no_documents: "No documents attached",
    create_incident: "Report Incident",
    create_request: "Create Request",
    // Approval
    approval_required: "Your Approval Required",
    approval_description:
      "This issue has been resolved and is waiting for your approval",
    approval_note: "Add a note",
    approval_note_accept_placeholder:
      "Describe why you are accepting this solution...",
    approval_note_reject_placeholder:
      "Please explain why you are rejecting this solution...",
    approval_note_required: "A note is required when rejecting",
    approval_predefined_note: "I accept this issue and agree to its closure.",
    accept_solution: "Accept Solution",
    reject_solution: "Reject Solution",
    confirm_accept: "Confirm Accept",
    confirm_reject: "Confirm Reject",
    feedback_title: "Rate Your Experience",
    feedback_subtitle: "How satisfied are you with the resolution?",
    unread: "Unread",
    unread_notifications: "Unread",
    read_notifications: "Read",
    archived: "Archived",
  },
};

export default en;
